import "./import/modules";
import $ from "jquery";
import "lazysizes";